import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import UploadView from "@/views/share/UploadView.vue";
import {computed} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SingleUploadView',
  props: {
    image: {},
    title: {}
  },
  emits: ['update:image', 'change'],
  setup(__props: any) {


const props = __props

const images = computed(() => props.image ? [props.image] : [])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UploadView, _mergeProps({
    images: images.value,
    max: 1,
    onChange: _cache[0] || (_cache[0] = args => _ctx.$emit('update:image', args.length == 1 ? args[0] : '')),
    "show-upload-button": "",
    "show-upload-list": {showRemoveIcon: false, showDownloadIcon: false}
  }, _ctx.$attrs), null, 16, ["images"]))
}
}

})